import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance
const api = axios.create({
    baseURL: API_URL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Auth API
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    getMe: () => api.get('/auth/me')
};

// Weight API
export const weightAPI = {
    getAll: () => api.get('/weight'),
    getLatest: () => api.get('/weight/latest'),
    create: (data) => api.post('/weight', data),
    update: (id, data) => api.put(`/weight/${id}`, data),
    delete: (id) => api.delete(`/weight/${id}`)
};

// Workouts API
export const workoutsAPI = {
    getAll: (params) => api.get('/workouts', { params }),
    getSummary: () => api.get('/workouts/summary'),
    create: (data) => api.post('/workouts', data),
    update: (id, data) => api.put(`/workouts/${id}`, data),
    delete: (id) => api.delete(`/workouts/${id}`)
};

// Bad Habits API
export const badHabitsAPI = {
    getAll: (params) => api.get('/bad-habits', { params }),
    getSummary: () => api.get('/bad-habits/summary'),
    create: (data) => api.post('/bad-habits', data),
    update: (id, data) => api.put(`/bad-habits/${id}`, data),
    delete: (id) => api.delete(`/bad-habits/${id}`)
};

// Settings API
export const settingsAPI = {
    getWorkoutTypes: () => api.get('/settings/workout-types'),
    createWorkoutType: (data) => api.post('/settings/workout-types', data),
    deleteWorkoutType: (id) => api.delete(`/settings/workout-types/${id}`),
    getBadHabitTypes: () => api.get('/settings/bad-habit-types'),
    createBadHabitType: (data) => api.post('/settings/bad-habit-types', data),
    deleteBadHabitType: (id) => api.delete(`/settings/bad-habit-types/${id}`)
};

// Analytics API
export const analyticsAPI = {
    getDashboard: () => api.get('/analytics/dashboard'),
    getHealthIndex: () => api.get('/analytics/health-index'),
    getWeightChart: (period) => api.get('/analytics/weight-chart', { params: { period } }),
    getWorkoutsChart: (period) => api.get('/analytics/workouts-chart', { params: { period } }),
    getBadHabitsChart: (period) => api.get('/analytics/bad-habits-chart', { params: { period } })
};

export default api;
